import permissions from '../../data/permissions';

export default [
    {
        name: "SupplierAccountCreate",
        path: "supplier-account",
        component: () => import('../../views/purchase/SupplierAccountCreateView.vue'),
        meta: { requiresAuth: true, authorization: permissions.supplier_account.create }
    },
    {
        name: "SupplierAccountDisplay",
        path: "supplier-account/:id",
        component: () => import('../../views/purchase/SupplierAccountDisplayView.vue'),
        meta: { requiresAuth: true, authorization: permissions.supplier_account.read }
    },
    {
        name: "SupplierAccountEdit",
        path: "supplier-account/:id/edit",
        component: () => import('../../views/purchase/SupplierAccountEditView.vue'),
        meta: { requiresAuth: true, authorization: permissions.supplier_account.update }
    },
    {
        name: "SupplierAccountStatementView",
        path: "supplier-account-statement",
        component: () => import('../../views/purchase/SupplierAccountStatementView.vue'),
        meta: { requiresAuth: true, authorization: permissions.report.supplier_account_statement }
    },
    {
        name: "SupplierAccountSummaryView",
        path: "supplier-account-summary",
        component: () => import('../../views/purchase/SupplierAccountSummaryView.vue'),
        meta: { requiresAuth: true, authorization: permissions.report.supplier_account_summary }
    },

]